









import { Component, Vue, Watch } from 'vue-property-decorator'
import firebase from '../firebase'
import { UserStoreMod } from '../store/user-store'
import * as firebaseui from 'firebaseui'

@Component
export default class LoginPage extends Vue {
  get authStateLoaded (): boolean {
    return UserStoreMod.firebaseAuthStateLoaded
  }

  get loggedIn (): boolean {
    return UserStoreMod.loggedIn
  }

  get showLogin (): boolean {
    return this.authStateLoaded && !this.loggedIn
  }

  @Watch('authStateLoaded', { immediate: false, deep: true })
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onAuthStateLoadedChanged (value: boolean, oldValue: boolean) {
    // console.log('login onAuthStateLoadedChanged', value)
    if (value === true) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.$f7!.preloader.hide()
    }
  }

  @Watch('loggedIn', { immediate: false, deep: true })
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onLoggedInChanged (value: string, oldValue: string) {
    // console.log('login onLoggedInChanged', value)
    if (value) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.$f7!.preloader.hide()
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.$f7router!.back('/vendor-admin-dash', { pushState: true })
    }
  }

  created () {
    // console.log('login created')
    if (!this.authStateLoaded) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.$f7!.preloader.show()
    }
  }

  mounted () {
    // console.log('login mounted')

    // Initialize the FirebaseUI Widget using Firebase.
    let ui = firebaseui.auth.AuthUI.getInstance()
    if (!ui) {
      ui = new firebaseui.auth.AuthUI(firebase.auth())
    }
    // The start method will wait until the DOM is loaded.
    ui.start('#firebaseui-auth-container', {
      signInOptions: [firebase.auth.GoogleAuthProvider.PROVIDER_ID],
      callbacks: {
        signInSuccessWithAuthResult: () => {
          // User successfully signed in.
          // do not redirect
          return false
        }
      }
    })

    if (this.showLogin) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.$f7!.preloader.hide()
    }
  }

  // sign in with just firebase.auth (not firebaseui)
  // signInWithRedirect (): void {
  //   // console.log('login-form signInWithRedirect')
  //   firebase.auth().signInWithRedirect(new firebase.auth.GoogleAuthProvider())
  // }
}
